// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7fpeC","top":"styles_top__RgdHl","left":"styles_left__3Ydw0","description":"styles_description__1x-Hm"};